import { ADD_ANTIHOMOTOXICOS } from "./types";

export const agregarAntihomotoxicos = (payload) => {
  return { type: ADD_ANTIHOMOTOXICOS, payload: payload };
};
